//@ts-nocheck
import { parseFullSymbol, checkTimeDiff, getExch_Exchtype_Scripcode, convertToEpochIST, } from "./helpers";
import { METHOD_FOR_CHART_SOCKET, OPT_FOR_CHART_SOCKET, } from "./utils/constant";
import { initFeedSocket, subscribeToData } from "./utils/websocketwrapper";
//define constants
let channelToSubscription = new Map();
let channelString = null;
let subcribedSocket = new Map();
initFeedSocket();
export const callBackForWebsocket = (data) => {
    var _a;
    var bar1;
    var bar2;
    let openRate;
    const getInfotvWidget = tvWidget.activeChart().symbol();
    let tvWidgetScriptCode = getExch_Exchtype_Scripcode(getInfotvWidget);
    if (data.LastRate !== undefined && data.LastRate !== null) {
        if (data.Token === Number(tvWidgetScriptCode.ScripCode)) {
            (_a = document.getElementById("tradVuTitle")) === null || _a === void 0 ? void 0 : _a.innerHTML = `${tvWidgetScriptCode.symbol} ${data.LastRate}`;
        }
    }
    let tradeTime;
    if (data.TickDt.includes("Date")) {
        tradeTime = convertToEpochIST(data.TickDt);
    }
    else {
        const isoDateString = data.TickDt;
        const regex = /(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):\d{2}\+\d{2}:\d{2}/;
        const match = isoDateString.match(regex);
        try {
            if (match) {
                const [, year, month, day, hour, minute] = match.map(Number);
                tradeTime = new Date(year, month - 1, day, hour, minute, 0);
                tradeTime.setSeconds(0);
                tradeTime.setMilliseconds(0);
                tradeTime = tradeTime.getTime();
            }
        }
        catch (e) {
            console.log(e);
        }
    }
    let subscriptionItem_minute = {};
    let subscriptionItem_day;
    for (let [key, subscriptions] of channelToSubscription) {
        const [, , , token] = key.split("~");
        const scFromkey = Number(token);
        if (scFromkey === data.Token) {
            subscriptions.forEach((subscription) => {
                const { resolution } = subscription;
                if (["1", "2", "3", "4", "5", "10", "15", "30", "60", "240"].includes(resolution)) {
                    // Store the subscription based on its resolution (e.g., 1 min, 5 min)
                    subscriptionItem_minute[resolution] = subscription;
                }
                else {
                    subscriptionItem_day = subscription;
                }
            });
        }
    }
    if (!subscriptionItem_day && !Object.keys(subscriptionItem_minute).length) {
        return;
    }
    let lastDailyBar_minute = {};
    let lastDailyBar_day;
    let nextDailyBarTime_minute = {};
    let nextDailyBarTime_day;
    // Process each minute interval subscription
    Object.keys(subscriptionItem_minute).forEach((resolution) => {
        const subscription = subscriptionItem_minute[resolution];
        if (subscription && subscription.lastDailyBar) {
            lastDailyBar_minute[resolution] = subscription.lastDailyBar;
            nextDailyBarTime_minute[resolution] = getNextDailyBarTime(lastDailyBar_minute[resolution].time);
            if (tradeTime >= nextDailyBarTime_minute[resolution]) {
                bar1 = {
                    time: new Date(tradeTime).setSeconds(0, 0),
                    open: data.LastRate,
                    high: data.LastRate,
                    low: data.LastRate,
                    close: data.LastRate,
                    volume: data.LastQty,
                };
            }
            else {
                bar1 = {
                    ...lastDailyBar_minute[resolution],
                    open: openRate ? openRate : lastDailyBar_minute[resolution].open,
                    high: Math.max(lastDailyBar_minute[resolution].high, data.LastRate),
                    low: Math.min(lastDailyBar_minute[resolution].low, data.LastRate),
                    close: data.LastRate,
                    volume: lastDailyBar_minute[resolution].volume + data.LastQty,
                };
            }
            // Update lastDailyBar and trigger handler for each minute resolution
            subscription.lastDailyBar = bar1;
            subscription.handlers[0].callback(bar1);
        }
        checkTimeDiff();
    });
    // Process daily interval subscription
    if (subscriptionItem_day && subscriptionItem_day.lastDailyBar) {
        lastDailyBar_day = subscriptionItem_day.lastDailyBar;
        nextDailyBarTime_day = getNextDailyBarTime(lastDailyBar_day.time);
        if (tradeTime >= nextDailyBarTime_day) {
            bar2 = {
                time: new Date(tradeTime).setUTCHours(0, 0, 0),
                open: data.OpenRate,
                high: data.High,
                low: data.Low,
                close: data.LastRate,
                volume: data.TotalQty,
            };
        }
        else {
            bar2 = {
                ...lastDailyBar_day,
                open: openRate ? openRate : lastDailyBar_day.open,
                high: Math.max(lastDailyBar_day.high, data.LastRate),
                low: Math.min(lastDailyBar_day.low, data.LastRate),
                close: data.LastRate,
            };
        }
        // Update lastDailyBar and trigger handler for daily resolution
        subscriptionItem_day.lastDailyBar = bar2;
        subscriptionItem_day.handlers[0].callback(bar2);
    }
    checkTimeDiff();
};
var getNextDailyBarTime = (barTime) => {
    const date = new Date(barTime);
    date.setSeconds(date.getSeconds() + 1);
    return date.getTime();
};
export var subscribeOnStream = async (symbolInfo, resolution, onRealtimeCallback, subscribeUID, onResetCacheNeededCallback, lastDailyBar) => {
    //onResetCacheNeededCallback(subscribeUID)
    let symbolToBePassed = symbolInfo.full_name.includes("/")
        ? symbolInfo.full_name.split("/")[0]
        : symbolInfo.full_name;
    const parsedSymbol = parseFullSymbol(symbolToBePassed.replace(/\s/g, ""));
    channelString = `0~${parsedSymbol.exchange}~${parsedSymbol.fromSymbol}~${symbolInfo.scripCode}`;
    const handler = {
        id: subscribeUID,
        callback: onRealtimeCallback,
    };
    let subscriptionItem;
    let subsItem;
    subsItem = channelToSubscription.get(channelString);
    if (subsItem == undefined)
        subsItem = [];
    //let lastDailyBarr = lastDailyBar.get(symbolInfo.ticker);
    subscriptionItem = {
        subscribeUID,
        resolution,
        lastDailyBar,
        handlers: [handler],
    };
    subscriptionItem.handlers.push(handler);
    subsItem.push(subscriptionItem);
    subcribedSocket.set(symbolInfo.scripCode, subscribeUID);
    subscribeToData({
        Method: OPT_FOR_CHART_SOCKET,
        Operation: METHOD_FOR_CHART_SOCKET,
        MarketFeedData: [
            {
                Exch: symbolInfo.exchange.split("")[0],
                ExchType: symbolInfo.exchType,
                ScripCode: symbolInfo.scripCode,
            },
        ],
    }, subscribeUID, callBackForWebsocket);
    channelToSubscription.set(channelString, subsItem);
    if (localStorage.getItem("sym_search_Tradechart") === "true") {
        localStorage.setItem("sym_search_Tradechart", "false");
    }
    localStorage.removeItem("layout_symbols");
};
export var unsubscribeFromStream = (subscriberUID) => {
    // find a subscription with id === subscriberUID
    for (const channelString of channelToSubscription.keys()) {
        const subscriptionItem = channelToSubscription.get(channelString);
        // const handlerIndex = subscriptionItem.handlers.findIndex(
        //   handler => handler.id === subscriberUID
        // );
        let handlerIndex;
        for (let i = 0; i < subscriptionItem.length; i++) {
            handlerIndex = subscriptionItem[i].handlers.findIndex((handler) => handler.id === subscriberUID);
        }
        if (handlerIndex !== -1) {
            if (subscriptionItem[0].handlers.length === 0) {
                subscriptionItem[0].handlers.splice(handlerIndex, 1);
                channelToSubscription.delete(channelString);
                break;
            }
        }
    }
};
